// The routes that serve watermarked previews to end users. Admin tools read
// /admin/_xphoto, so they are left alone.
export const PREVIEW_PATHS = ["/system/xphoto/webshop", "/system/XPhoto.php"];
/**
 * Matches a preview in an img, or as an inline background-image, which is how
 * both the React webshop and the legacy pages show them. Same selectors as
 * WebshopPrintProtection::getPreviewSelectors().
 */
export const previewSelectors = PREVIEW_PATHS.flatMap((path) => [
    `img[src*="${path}"]`,
    `[style*="${path}"]`,
]);
